import { mdiCalendarCheckOutline } from "@mdi/js";
import _DatabaseModel from "./_DatabaseModel";

class Task extends _DatabaseModel {
  static model = "task";
  static editDialogComponent = "issue-task-edit-dialog";
  static cardComponent = "task-card";

  static tableHeaders = [
    { textKey: "form.label.id", value: "id", sortable: false },
    { textKey: "form.label.name", value: "name" },
    { textKey: "form.label.created_at", value: "created_at" },
    { textKey: "form.label.updated_at", value: "updated_at" },
  ];

  static filter = {
    parts: {
      fields: [
        "service_id",
        "user_id",
        "issue_task_statuses",
        "all_tasks",
        "team_id",
      ],
      extended_fields: [],
    },
  };

  static show = {
    reloadingModels: ["work_report", "task"],
  };

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
      {
        labelKey: "form.label.author",
        value: object.author,
        type: "link",
        to: "users",
      },
      {
        labelKey: "issue.issue",
        value: object.issue_service?.issue,
        type: "link",
        to: "issues",
      },
      {
        labelKey: "price_list.price_list",
        value: object.price_list,
        type: "link",
        to: "price_lists",
      },
      {
        labelKey: "task.label.plan_start",
        value: object.plan_start,
        type: "date_time",
      },
      {
        labelKey: "task.label.plan_end",
        value: object.plan_end,
        type: "date_time",
      },
      {
        labelKey: "person.persons",
        value: object.task_users?.map((u) => {
          return { name: u.user.person.name, id: u.user.person_id };
        }),
        type: "link_array",
        to: "persons",
      },
      {
        labelKey: "asset.assets",
        value: object.task_assets?.map((a) => {
          return { name: a.asset.name, id: a.asset.id };
        }),
        type: "link_array",
        to: "assets",
      },
    ];
  }

  static tabs = [
    this.detailTab,
    {
      titleKey: "issue_note.issue_notes",
      component: "IssueNotesTab",
      disabled: (object) => !!object.closed_at || object.status === "inactive",
    },
    {
      titleKey: "document.documents",
      component: "DocumentsTab",
      disabled: (object) => !!object.closed_at || object.status === "inactive",
    },
    {
      titleKey: "task.label.resources",
      component: "TaskResourcesTab",
      disabled: (object) => object.status === "inactive",
    },
    {
      titleKey: "work_report.work_reports",
      component: "WorkReportsTab",
      disabled: () => false,
    },
  ];

  static cardFields(object) {
    return {
      title: object.name,
      src: {
        cardIcon: mdiCalendarCheckOutline,
      },
    };
  }
}

export default Task;
